const svg = `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="82.833px" height="83px" viewBox="0 0 82.833 83" enable-background="new 0 0 82.833 83" xml:space="preserve">
	<path fill="#CA5E46" d="M48.007,41.591l33.887,33.887c0.495,0.655,0.742,1.398,0.742,2.226c0,0.829-0.247,1.484-0.742,1.979
		l-2.226,2.226c-0.495,0.495-1.156,0.742-1.979,0.742s-1.564-0.247-2.226-0.742L41.576,47.775L7.689,81.909
		c-0.662,0.495-1.404,0.742-2.226,0.742s-1.484-0.247-1.979-0.742l-2.226-2.226c-0.495-0.495-0.742-1.15-0.742-1.979
		c0-0.829,0.247-1.571,0.742-2.226l34.134-33.887L1.258,7.704C0.763,7.049,0.516,6.307,0.516,5.478s0.247-1.484,0.742-1.979
		l2.226-2.226C3.979,0.779,4.64,0.531,5.463,0.531s1.564,0.247,2.226,0.742L41.576,35.16L75.462,1.273
		c0.662-0.495,1.404-0.742,2.226-0.742s1.484,0.247,1.979,0.742l2.226,2.226c0.495,0.495,0.742,1.15,0.742,1.979
		s-0.247,1.571-0.742,2.226L48.007,41.591z"/>
</svg>
`

const favorite = {
    init: () => {
        favorite.updateHeader();
        favorite.initContactForm();
    },
    initContactForm: () => {
        let type = 0; // if we are in favorites
        let data = [];
        let dataSaved = [];

        const nr = $('.form-apart-list').data('nr');
        if (nr == undefined) {
            type = 1; 
            let favoriteData = JSON.parse(Cookies.get('favorites') || null);
            if (favoriteData != null) {
            data = favoriteData;
            }
        } else {
            data = [nr];
        }

        $('.form-apart-list span').empty();
        for(let i = 0; i < data.length; i++) {
            let x = data[i];
            if (type == 1) {
                x = $(`span[data-id='${x}']`).data('title');
            }

            dataSaved.push(x);
            $(".form-apart-list").prepend(`<span data-id=${x} class="item">${x}<span class="close">${svg}</span></span>`); 
        }

        $('#footer-form-favorites0').val(JSON.stringify(dataSaved));
        $('#footer-form-favorites1').val(JSON.stringify(dataSaved));
    },
    updateContactForm: (id) => {
        if (id === undefined) return;
        let data = JSON.parse($('#footer-form-favorites1').val());
        const index = data.findIndex(e => e === id);
        if(index != -1) {
            data.splice(index, 1);
        }

        $('.form-apart-list span').empty();
        for(let i = 0; i < data.length; i++) {
            $(".form-apart-list").prepend(`<span data-id=${data[i]} class="item">${data[i]}<span class="close">${svg}</span></span>`); 
        }

        $('#footer-form-favorites1').val(JSON.stringify(data));

    },
    updateTable: (container = document) => {
        let favoriteData = JSON.parse(Cookies.get('favorites') || null);
        if (favoriteData == null) {
            favoriteData = [];
        }

        let $favorites = container.find('.favorites');
        $favorites.each(function() {
            let $this = $(this);
            let id = $this.data('id');
            if(favoriteData.includes(id)) {
                $this.addClass('active');
            }
        });
    },

    updateHeader: () => {
        let favoriteData = JSON.parse(Cookies.get('favorites') || '[]');
        if (favoriteData.length != 0) {
            if($('').hasClass('active') == false) $('.favorites-header').addClass('active');
            $('.favorites-header .ftotal-js').show();
            $('.favorites-header .ftotal-js').text(favoriteData.length);
        } else {
            $('.favorites-header .ftotal-js').hide();
            $('.favorites-header').removeClass('active');
        }
    },

    updateApartment: () => {
        let id = $('.apartment-page').data('id');
        let favoriteData = JSON.parse(Cookies.get('favorites') || '[]');
        if(favoriteData.includes(id)) {
            $('.favorites-apartments').addClass('active');
        }
    }
}


favorite.init();
favorite.updateTable($('.aparts-table'));

//only run on apartments_apartment
favorite.updateApartment();
